import { useState } from "react";
import MenuFrame from "../frames/menu_frame";
import { Alert, Autocomplete, Backdrop, Box, Button, CircularProgress, Grid, Paper, TextField } from "@mui/material";
import { validCn } from "../booking/booking_halper";
import { newInventoryCn } from "./inventory_halper";

function Inventory() {
    const [alertMessage, setAlertMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const validateInputs = () => {
        return true;
    }

    const handleInvontrySubmit = (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        const series = data.get("series");
        const s_start = Number(data.get("s_start"));
        const s_end = Number(data.get("s_end"));
        const start_cn = series + String(s_start).padStart(8, '0');
        const end_cn = series + String(s_end).padStart(8, '0');

        if (s_start === 0 || s_start > 99999999999 || !validCn(start_cn)) {
            setAlertMessage({ "severity": "warning", "message": "Starting number of CN is invalid. (" + start_cn + ")" })
            return;
        }
        if (s_end === 0 || s_end > 99999999999 || !validCn(end_cn)) {
            setAlertMessage({ "severity": "warning", "message": "Ending number of CN is invalid. (" + end_cn + ")" })
            return;
        }
        if (s_end <= s_start) {
            setAlertMessage({ "severity": "warning", "message": "Starting and ending CN number is invalid." })
            return;
        }

        setIsLoading(true);
        newInventoryCn(series, s_start, s_end).then((_) => {
            setIsLoading(false);
            setAlertMessage({ "severity": "success", "message": "Inventory item added." })
        }).catch((err) => {
            setIsLoading(false);
            setAlertMessage({ "severity": "warning", "message": err.message })
        });
    }


    return (
        <MenuFrame permission={"INVENTORY"}>
            {alertMessage === null ? "" :
                <Box>
                    <Alert severity={alertMessage.severity}>{alertMessage.message}</Alert>
                </Box>
            }
            <Backdrop sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} open={isLoading} >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Box size={{ xs: 12, sm: 10 }} component="form" onSubmit={handleInvontrySubmit}>
                <Grid container spacing={2} component={Paper} sx={{ p: 2 }}>
                    <Grid size={{ xs: 12, sm: 4 }}>
                        <Autocomplete
                            disablePortal
                            options={["K", "D", "V", "G", "N", "I", "7D"]}
                            defaultValue={"K"}
                            renderInput={(params) => <TextField {...params} variant="outlined" name="series" fullWidth type="text" placeholder="Series" label="Series" />}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }}>
                        <TextField variant="outlined" name="s_start" fullWidth type="number" slotProps={{ htmlInput: { step: 1, min: 0, max: 9999999999 } }} placeholder="Series Start" label="Series Start" />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }}>
                        <TextField variant="outlined" name="s_end" fullWidth type="number" slotProps={{ htmlInput: { step: 1, min: 0, max: 9999999999 } }} placeholder="Series End" label="Series End" />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12 }}>
                        <Button type="submit" variant="contained" fullWidth onClick={validateInputs} color="info" style={{ textTransform: "none" }}>Save to Inventory</Button>
                    </Grid>
                </Grid>
            </Box>
        </MenuFrame>
    );
}

export default Inventory;
